/** Fields used when matching a restaurant against a search query. */
export type RestaurantSearchFields = {
  id: string;
  name: string;
  city?: string | null;
  region?: string | null;
  label?: string | null;
};

/** Split a query on commas into trimmed, lowercased terms (empty terms dropped). */
export function parseRestaurantSearchTerms(query: string): string[] {
  return query
    .split(',')
    .map(t => t.trim().toLowerCase())
    .filter(Boolean);
}

/**
 * Match a restaurant against a search query.
 * - Empty / whitespace-only query matches everything.
 * - Comma-separated terms are OR'd (any term can match).
 * - Each term matches id, name, city, region, or label (substring, case-insensitive).
 */
export function restaurantMatchesSearch(
  restaurant: RestaurantSearchFields,
  query: string,
): boolean {
  const terms = parseRestaurantSearchTerms(query);
  if (!terms.length) return true;
  const haystack = [
    restaurant.id,
    restaurant.name,
    restaurant.city ?? '',
    restaurant.region ?? '',
    restaurant.label ?? '',
  ].map(s => String(s).toLowerCase());
  return terms.some(term => haystack.some(field => field.includes(term)));
}
